import React from "react";
import { useCartContext } from "../../cart";
import { useTenantContext } from "../../tenant/TenantContext";
import { ContainerTitle } from "../../components/Theme/theme.elements";
import { ContainerMenu, Totales, Valortotal, Valortotales } from "../../ui";
import { FormattedNumber } from "../../common/ui/FormattedNumber";
import { onDemandAmount, onDemandTaxedAmount } from "../../cart/domain/onDemandSplit";

// todo: move to domain logic
const DeliveryCosts = ({ subtotal, deliveryCostThreshold, hasRefrigeratedProducts }) => {
    if (subtotal >= deliveryCostThreshold) {
        return <small className="text-success">Envío gratuito.</small>;
    }

    if (hasRefrigeratedProducts) {
        return (
            <small className="text-danger">
                Coste de envío frío: 9,5€.<br />
                Envío gratuito a partir de {deliveryCostThreshold}€.
            </small>
        );
    }

    return (
        <small className="text-danger">
            Coste de envío para pedidos de menos de 10 kg es 6€.<br />
            Para pedidos con más de 10kg es 9,5€.<br />
            Envío gratuito a partir de {deliveryCostThreshold}€.
        </small>
    );
};

export const OrderRecap = () => {
    const { cart, loading } = useCartContext();
    const tenant = useTenantContext();

    // Default TRUE para no romper tenants que no tengan la clave
    const deliveryCostsEnabled = tenant?.deliveryCosts?.enabled ?? true;
    const deliveryCostThreshold = tenant?.deliveryCosts?.threshold ?? 120;

    // Las unidades bajo pedido (exceso de las líneas bypass sin stock) van fuera
    // del Total del resumen: el Total enseña solo lo que llega ahora y lo bajo
    // pedido sale como línea aparte. Tampoco cuentan para el pedido mínimo del
    // envío gratuito. El pedido que se tramita sigue incluyéndolo todo.
    const onDemandExcess = onDemandAmount(cart?.products ?? []);
    const onDemandExcessTaxed = onDemandTaxedAmount(cart?.products ?? []);
    const servedSubtotal = Math.max((cart?.subtotal ?? 0) - onDemandExcess, 0);
    const servedTotal = Math.max((cart?.total ?? 0) - onDemandExcessTaxed, 0);

    return loading ? (
        <div className="text-center m-4">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    ) : (
        !!cart && (
            <ContainerMenu className="filtroMacroFamilia">
                <ContainerTitle>Resumen de tu pedido</ContainerTitle>

                <Totales>Descuentos aplicables</Totales>
                <Valortotales>
                    <FormattedNumber value={cart.discount} config={{ style: "currency" }} />
                </Valortotales>

                <Totales>Total</Totales>
                <Valortotal>
                    <FormattedNumber value={servedSubtotal} config={{ style: "currency" }} />
                </Valortotal>

                {onDemandExcess > 0 && (
                    <>
                        <Totales>Bajo pedido</Totales>
                        <Valortotales>
                            <FormattedNumber value={onDemandExcess} config={{ style: "currency" }} />
                        </Valortotales>
                    </>
                )}

                <div className="d-flex flex-column mt-2 gap-1">
                    <small className="text-muted">
                        IVA no incluido. Total con IVA: <FormattedNumber value={servedTotal} config={{ style: "currency" }} />
                    </small>
                    {onDemandExcess > 0 && (
                        <small className="text-muted">
                            El Total no incluye las unidades bajo pedido
                            (<FormattedNumber value={onDemandExcess} config={{ style: "currency" }} /> sin IVA):
                            se pedirán igualmente y te llegarán más tarde en un pedido diferente.
                        </small>
                    )}

                    {deliveryCostsEnabled && (
                        <DeliveryCosts
                            subtotal={servedSubtotal}
                            deliveryCostThreshold={deliveryCostThreshold}
                            hasRefrigeratedProducts={cart.products.some(({ refrigerated }) => refrigerated)}
                        />
                    )}
                </div>
            </ContainerMenu>
        )
    );
};
